import { Marketplace, SETTINGS_TRUE_VALUE } from '@spike/marketplace-model';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import store from 'store';
import { hasPremiumAccess } from './premiumPlan';
import { useMarketplace } from './useMarketplace';

export const OMNICHANNEL_INBOX_SETTING_KEY = 'omnichannel_inbox';

export const isOmnichannelInboxEnabled = (
    marketplace: Marketplace | undefined = store.getState().marketplace.marketplace
): boolean => {
    const settingEnabled =
        marketplace?.settings?.find(setting => setting.key === OMNICHANNEL_INBOX_SETTING_KEY)?.value ===
        SETTINGS_TRUE_VALUE;

    const { subscriptions } = store.getState().subscriptions;
    const { resourceAccessPlans } = store.getState().masterData.data;
    const timeZone = store.getState().login.auth.timeZone;

    return settingEnabled && hasPremiumAccess(subscriptions, resourceAccessPlans, `${timeZone}`, 'two_way_sms');
};

export const useOmnichannelInboxEnabled = (): boolean => {
    const marketplace = useMarketplace();
    const subscriptions = useSelector((state: RootState) => state.subscriptions.subscriptions);
    const resourceAccessPlans = useSelector((state: RootState) => state.masterData.data.resourceAccessPlans);
    const timeZone = useSelector((state: RootState) => state.login.auth.timeZone);

    const settingEnabled =
        marketplace.settings?.find(setting => setting.key === OMNICHANNEL_INBOX_SETTING_KEY)?.value ===
        SETTINGS_TRUE_VALUE;

    return settingEnabled && hasPremiumAccess(subscriptions, resourceAccessPlans, `${timeZone}`, 'two_way_sms');
};

export default useOmnichannelInboxEnabled;
